// NOTE: disabled ctaReference to single faq page
import "./index.scss";
// import {
//   // Icon,
// } from "@wise-emotions/web-telepass-design-library";
import { Accordion } from "@wise-emotions/react-accordion";
import { FaqListPreviewProps } from "./types";
import AccordionGroup from "components/Accordion/AccordionGroup";
import React from "react";
import parse from "html-react-parser";
// import CtaReference from "../CtaReference"

const FaqListPreview = (props: FaqListPreviewProps) => {
  return (
    <div className="FaqListPreview">
      <AccordionGroup>
        {props.faqs.map((item) => {
          const abstract = item.abstract?.abstract
            ? parse(item.abstract.abstract)
            : "";
          const title = item.title ? (parse(item.title) as string) : "";
          return (
            <Accordion variant="default" key={item.id} title={title}>
              <div className="FaqListPreview__item__content editorial">
                {abstract}
              </div>
              {/* INFO: NON CANCELLARE: CTA DA ATTIVARE UNA VOLTA RIABILITATE LE PAGINE */}
              {/* <div className="FaqListPreview__item__cta">
                  <CtaReference
                    ctaType="internalStaticLink"
                    internalStaticLink={item.currentItemPageUrl}
                    customClass="FaqListPreview__item__link"
                  >
                    <span>{get(labelCta, '[0].text.text')}</span>
                    <Icon iconName="arrow-right" />
                  </CtaReference>
                </div> */}
            </Accordion>
          );
        })}
      </AccordionGroup>
    </div>
  );
};

export default FaqListPreview;
